import React from "react";

const ProfilePage = ({ agentProfile, setAgentProfile }) => {
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <div className="text-center">
        <h2 className="dark-header !text-[#000]">Agent Profile</h2>
        <p className="light-header">Manage your professional information</p>
      </div>
      
      <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block font-medium mb-3 text-[#000]">Agent Type</label>
              <select 
                value={agentProfile.type}
                onChange={(e) => setAgentProfile({...agentProfile, type: e.target.value})}
                className="w-full p-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#10c9c0] focus:border-[#10c9c0] transition-all"
              >
                <option value="individual">Individual Agent</option>
                <option value="company">Company</option>
              </select>
            </div>
            
            <div>
              <label className="block font-medium mb-3 text-[#000]">Name</label>
              <input 
                type="text"
                value={agentProfile.name}
                onChange={(e) => setAgentProfile({...agentProfile, name: e.target.value})}
                placeholder="Your name or company name"
                className="w-full p-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#10c9c0] focus:border-[#10c9c0] transition-all"
              />
            </div>
          </div>
          
          {agentProfile.type === 'individual' && (
            <div>
              <label className="block font-medium mb-3 text-[#000]">Company (Optional)</label>
              <input 
                type="text"
                value={agentProfile.company}
                onChange={(e) => setAgentProfile({...agentProfile, company: e.target.value})}
                placeholder="Company you work for"
                className="w-full p-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#10c9c0] focus:border-[#10c9c0] transition-all"
              />
            </div>
          )}
          
          <div>
            <label className="block font-medium mb-3 text-[#000]">Password</label>
            <input 
              type="password"
              value={agentProfile.password}
              onChange={(e) => setAgentProfile({...agentProfile, password: e.target.value})}
              placeholder="Choose a secure password"
              className="w-full p-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#10c9c0] focus:border-[#10c9c0] transition-all"
            />
          </div>
          
          <div className="pt-6 border-t border-gray-100">
            <h3 className="dark-header !text-[#000] !mb-6 !text-xl">Contact Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <input 
                type="email"
                value={agentProfile.contactInfo.email}
                onChange={(e) => setAgentProfile({
                  ...agentProfile, 
                  contactInfo: {...agentProfile.contactInfo, email: e.target.value}
                })}
                placeholder="Email address"
                className="w-full p-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#10c9c0] focus:border-[#10c9c0] transition-all"
              />
              <input 
                type="tel"
                value={agentProfile.contactInfo.phone}
                onChange={(e) => setAgentProfile({
                  ...agentProfile, 
                  contactInfo: {...agentProfile.contactInfo, phone: e.target.value}
                })}
                placeholder="Phone number"
                className="w-full p-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#10c9c0] focus:border-[#10c9c0] transition-all"
              />
            </div>
            <div className="mt-6">
              <textarea 
                value={agentProfile.contactInfo.address}
                onChange={(e) => setAgentProfile({
                  ...agentProfile, 
                  contactInfo: {...agentProfile.contactInfo, address: e.target.value}
                })}
                placeholder="Business address"
                rows="4"
                className="w-full p-4 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#10c9c0] focus:border-[#10c9c0] transition-all"
              />
            </div>
          </div>
          
          <button className="w-full bg-gradient-to-r from-[#10c9c0] to-[#0eb1a9] text-white py-4 rounded-xl hover:from-[#0eb1a9] hover:to-[#10c9c0] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 font-medium">
            <i className="fas fa-save mr-2"></i>
            Save Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;